import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from 'antd';

const defaultAvatarImg = require('assets/images/profile/default-avatar.png');

const getInitials = (name) => {
  const username = name || '';
  let initials = '';

  const nameSplit = String(username)
    .toUpperCase()
    .split(' ');
  if (nameSplit.length === 1) {
    initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
  }
  else {
    initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
  }
  return initials;
};

class ExtendedAvatar extends React.Component {
  static propTypes = {
    icon: PropTypes.string,
    shape: PropTypes.string,
    size: PropTypes.string,
    src: PropTypes.string,
    name: PropTypes.string,
    defaultAvatar: PropTypes.string
  };

  static defaultProps = {
    icon: null,
    shape: 'circle',
    size: 'default',
    src: null,
    name: null,
    defaultAvatar: 'image' // Default to display user initials if icon or src is not supplied. Values are of 'letter', 'image', 'icon'
  };

  getLetterAvatar() {
    const { name, shape, size } = this.props;

    const textColor = '#ffffff';
    const alphabetColors = [
      '#1abc9c',
      '#2ecc71',
      '#3498db',
      '#9b59b6',
      '#34495e',
      '#16a085',
      '#27ae60',
      '#2980b9',
      '#8e44ad',
      '#2c3e50',
      '#f1c40f',
      '#e67e22',
      '#e74c3c',
      '#ecf0f1',
      '#95a5a6',
      '#f39c12',
      '#d35400',
      '#c0392b',
      '#bdc3c7',
      '#7f8c8d'
    ];

    const initials = getInitials(name);
    const charIndex = (initials === '?' ? 72 : initials.charCodeAt(0)) - 64;
    const colorIndex = charIndex % (alphabetColors.length + 1);
    const backgroundColor = colorIndex >= 1 && colorIndex <= alphabetColors.length
      ? alphabetColors[colorIndex - 1]
      : '#ff0000';

    const style = {
      color: textColor,
      backgroundColor
    };

    return {
      children: initials,
      style,
      shape,
      size
    };
  }

  getImageAvatar() {
    const { src, shape, size } = this.props;
    return {
      src: src || defaultAvatarImg,
      shape,
      size
    };
  }

  getIconAvatar() {
    const { icon, shape, size } = this.props;
    return {
      icon: icon || 'user',
      shape,
      size
    };
  }

  getDefaultAvatar() {
    const { defaultAvatar } = this.props;
    let avatar = {};
    switch (defaultAvatar) {
    case 'letter':
      avatar = this.getLetterAvatar();
      break;

    case 'image':
      avatar = this.getImageAvatar();
      break;

    case 'icon':
      avatar = this.getIconAvatar();
      break;

    default:
      avatar = this.getLetterAvatar();
      break;
    }
    return avatar;
  }

  getAvatar() {
    const { src, icon, name } = this.props;
    let avatar = {};

    if (src) {
      avatar = this.getImageAvatar();
    }
    else if (icon) {
      avatar = this.getIconAvatar();
    }
    else if (name) {
      avatar = this.getLetterAvatar();
    }
    else {
      avatar = this.getDefaultAvatar();
    }
    return avatar;
  }

  render() {
    return <Avatar {...this.getAvatar()} />;
  }
}

export default ExtendedAvatar;
